module.exports = __webpack_public_path__ + "static/media/up-globas.3bd0b487.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/economy/up-globas.svg
// module id = 43
// module chunks = 0